import axios from "axios";

// Not working for some reason so ignoring for now

// const api = axios.create({
//     baseUrl: 'http://localhost:8000'
// });

// Recieving jwt token and sending it in the form of a bearer token

// axios.interceptors.request.use req -----------> to pick the jwt from the local storage which we are saving while signing in

axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';

axios.interceptors.request.use(req => {
	let temp = JSON.parse(localStorage.getItem("authDetails"));

	// console.log(temp, " \n------------------\nIam token outside\n");

	if (temp?.tokenId) {
		const token = temp.tokenId;
		// console.log(token, " Iam token\n\n");
		req.headers.authorization = "Bearer " + token;
	} else if (temp?.token) {
		const token = temp.token;
		// console.log(token, " Iam token\n\n");
		req.headers.authorization = "Bearer " + token;
	}

	// console.log(req.headers, "\n--------------\n\nIam headers in API\n\n");
 
	return req;
});

const url = "https://memories-app-react-redux.herokuapp.com";

export const fetchPost = async () => axios.get(url + '/index');

export const createPost = async newPost => {
	// return axios.post(url, newPost);             // Forgot this " return "" mofo which costed me a day pfft :/
	return axios.post(url + "/index", newPost);
};

export const updatePost = async (id, updatedPost) => {
	// return axios.patch(`${url}/${id}`, updatedPost);          // Earlier we were using this but we can simply put a baseUrl in axios to make things easier
	return axios.patch(url + `/index/${id}`, updatedPost); // because now we dont have only one single routes but many different routes
};

export const deletePost =  async id => {
	// axios.delete(`/${url}/${id}`);
	return axios.delete(url + `/index/${id}`);
};

export const likePost =  async id => {
	// return axios.patch(`${url}/${id}/likePost`);
	// console.log(id, " \nIam id in api\n\n");
	return axios.patch(url + `/index/${id}/likePost`);
};

// Now the sign in and singout routes;;;;;;;

export const signIn =  async postData => {
	return axios.post(url + `/users/signin`, postData);
};

export const signUp =  async formData => {
	// console.log(formData, " zzzzzz iam in axios\n\n");
	return axios.post(url + "/users/signup", formData);
};
